<template>
  <div id="PrivacyPolicy" class="container-fluid px-0">
    <div class="main no-side-bar">
      <nav v-if="$store.state.user.authenticated">
        <Navigation></Navigation>
      </nav>
      <main class="content-wrap">
        
        <div class="content-container row py-5">
          <div role="document" class="content-card w-100 p-5">
            <div class="mt-5">
              <h1 class="page-title brand-highlight-1">Privacy Policy</h1>
            </div>
            <div
              class="content-inner p-md-5 m-md-5 p-0 m-0 brand-text"
              v-html="decodeData(content)"
            ></div>
            <div
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
                mt-5
                brand-text
              "
              v-if="
                !this.$store.getters.user.user.pp_accepted &&
                  $store.state.user.authenticated
              "
            >
              <div class="d-flex flex-row align-items-center mb-4">
                <input
                  type="checkbox"
                  id="agree-checkbox"
                  v-model="checkbox"
                  aria-label="Agree to privacy policy"
                  class="checkbox"
                />
                <label for="agree-checkbox" class="ml-2">
                  I have read and agree to the above privacy policy.
                </label>
              </div>

              <b-button
                class="cta-button px-5 pt-3 pb-4"
                :disabled="!checkbox"
                @click="agreeToPP()"
                aria-label="Agree to privacy policy"
              >
                <span v-if="agreementSuccess === false">Agree!</span>
                <span v-else>Success!</span>
              </b-button>
            </div>
            <div
              v-else-if="agreementSuccess"
              class="d-flex justify-content-center"
            >
              <p class="brand-text">
                You have successfully agreed to the privacy policy, you'll be
                redirectly shortly..
              </p>
            </div>
          </div>
        </div>
      </main>
      <footer>
        <Footer></Footer>
      </footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import config from "../config/constants";
import Navigation from "@/components/Navigation.vue";
import MobileNav from "@/components/MobileNav.vue";
import Footer from "../components/Footer";
export default {
  name: "Privacy",
  components: {
    Footer,
    Navigation,
    MobileNav
  },
  data() {
    return {
      agreementSuccess: false,
      checkbox: false,
      content: "",
      isLoading: true
    };
  },
  mounted() {
    if (this.$route.query.lang) {
      this.$store.commit("setLanguage", this.$route.query.lang);
    }
    this.getPrivacyPolicy();
  },
  methods: {
    toggleCheckbox() {
      this.checkbox = !this.checkbox;
    },
    async agreeToPP() {
      if (this.checkbox) {
        const payload = {
          user_id: this.$store.getters.user_id,
          terms_type: ["pp"]
        };
        let res = await axios.post(
          config.api_env + "/application/api/u/user/accept-terms",
          payload,
          config.options
        );
        if (res.data.success) {
          let self = this;
          this.$store.dispatch("setUserPPAgreementTrue");
          this.agreementSuccess = true;
          setTimeout(function() {
            self.$router.push("/");
          }, 2000);
        } else if (res.data.err && res.data.err.includes("3994")) {
          this.$store.dispatch("logout");
          this.$router.push("/login").catch(err => {});
        }
      }
    },
    decodeData(data) {
      try {
        return Buffer.from(data, "base64");
      } catch (error) {
        try{
          return atob(data);
        } catch {
          return data;
        }
      }
    },
    async getPrivacyPolicy() {
      let slug = this.$store.getters.user.user_pp_slug;
      if (slug === "generic_pp" && this.$store.getters.client.pp_slug) {
        slug = this.$store.getters.client.pp_slug;
      }
      const payload = {
        slug: 'axa_pp'
      };
      let res = await axios.post(
        config.api_env + "/application/api/u/info/get-info",
        payload,
        config.options
      );
      if (res.data.success) {
        this.content = res.data.dynamic_string.string;
        this.isLoading = false;
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login").catch(err => {});
      }
    }
  },
  computed: {
    componentText() {
      return this.getText.privacy;
    }
  },
  watch: {
    skin(newVal) {
      this.$store.commit("setSkin", newVal);
    }
  }
};
</script>
<style lang="less">
#PrivacyPolicy {
  .bg-white{
    background-color: white;
  }
  td {
    border: 1px solid black !important;
    padding: 3px;
  }

  strong {
    font-family: "DMSans Bold", sans-serif;
  }

  font-size: 1.6rem;
  font-family: "DMSans", sans-serif;
  .page-title {
    text-align: center;
    font-size: 3rem;
  }
  .content-wrap {
    background: #f4f4f4;

    .content-inner a {
      color: #0040ff;

      &:hover {
        color: #3366ff;
      }
    }

    .content-card {
      background: #ffffff;
      max-width: 1000px;
      margin: auto;
    }
  }

  .checkbox {
    width: 20px;
    height: 20px;
    border: 2px solid #3a4961;
    margin-right: 8px;
  }

  label {
    margin-bottom: 0;
  }

  @media (max-width: 992px) {


    .content-card {
      transform: translateY(0);
    }
  }
}
</style>
